import script from "./TabbedRouterView.vue?vue&type=script&setup=true&lang=ts"
export * from "./TabbedRouterView.vue?vue&type=script&setup=true&lang=ts"

import "./TabbedRouterView.vue?vue&type=style&index=0&id=002293a8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-002293a8"]])

export default __exports__